<div mat-dialog-content class="dialog-container">
  <h2>{{title}}</h2>
  <form [formGroup]="form">
    <div class="flex-column">
      <mat-form-field>
        <mat-label>Almacen</mat-label>
        <mat-select formControlName="idalmacen">
          <mat-option *ngFor="let store of stores" [value]="store.id">
            {{store.nombre}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Producto</mat-label>
        <input matInput [matAutocomplete]="product" formControlName="idproducto" placeholder="Selecciones un producto">
        <mat-autocomplete
          autoActiveFirstOption
          #product="matAutocomplete"
          [displayWith]="displayProduct"
          (optionSelected)="productChanged()"
        >
          <mat-option *ngFor="let product of products" [value]="product">
            {{product.nombre}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Comunidad</mat-label>
        <mat-select formControlName="idcomunidad">
          <mat-option *ngFor="let comunidad of comunidades" [value]="comunidad.id">
            {{comunidad.nombre}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex-row flex-column-gap-8">
      <div>
        <mat-form-field>
          <mat-label>Fecha</mat-label>
          <input matInput type="text" [matDatepicker]="picker" formControlName="fecha" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <mat-form-field>
        <mat-label>Cantidad</mat-label>
        <input matInput type="number" formControlName="cantidad" />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field>
        <mat-label>Numeración</mat-label>
        <input matInput type="text" formControlName="numeracion" />
      </mat-form-field>
    </div>
    <div class="actions">
      <button mat-button (click)="close()">Cerrar</button>
      <button mat-raised-button color="primary" (click)="save()">Guardar</button>
    </div>
  </form>
</div>
